import { render } from "./AddCountry.vue?vue&type=template&id=19b0df63"
import script from "./AddCountry.vue?vue&type=script&lang=js"
export * from "./AddCountry.vue?vue&type=script&lang=js"

import "./AddCountry.vue?vue&type=style&index=0&id=19b0df63&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__